import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClusterService, TanMax } from 'src/app/core/cluster.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';

@Component({
  selector: 'app-cluster-delete-tan-max-dialog',
  templateUrl: './cluster-delete-tan-max-dialog.component.html',
})
export class ClusterDeleteTanMaxDialogComponent {
  tan_max: TanMax;
  is_delete_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<ClusterDeleteTanMaxDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: { tan_max: TanMax },
    private cluster_service: ClusterService,
    private error_service: ErrorService,
  ) {
    this.tan_max = data.tan_max;
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onDeleteClick(): void {
    this.is_delete_running = true;
    this.cluster_service.deleteTanMax(this.tan_max.tan_max_id).subscribe({
      next: () => this.dialog_ref.close({ success: true }),
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
      },
    });
  }
}